/* eslint-disable no-underscore-dangle */
import { AxiosInstance } from 'axios';
import { LocalStorageItems, SessionStorageItems } from 'shared/constants';

import { BEErrorHandler } from '../error';
import getStaticCandidateToken from './getStaticCandidateToken';
import { InterceptorArgs } from './interceptors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AxiousError = any;

export default async function onResponseError(args: InterceptorArgs, axiosInstance: AxiosInstance, error: AxiousError) {
    const { response, config: originalRequest } = error;

    if (response.status === 401 && originalRequest) {
        if (originalRequest._retry) {
            return Promise.reject(error);
        }

        if (error.response.data?.errorCode === 'misconfigured_tenant') {
            return tryRetryMisconfiguredTenant(axiosInstance, error);
        }

        return tryRetryAuthTokenError(axiosInstance, error);
    }

    if (!originalRequest?.isCancel) {
        const ErrorHandler = new BEErrorHandler(error);
        error.globusError = ErrorHandler.handle();
    }
    
    return Promise.reject(error);
}

function tryRetryMisconfiguredTenant(axiosInstance: AxiosInstance, error: AxiousError) {
    const { response, config: originalRequest } = error;
    const alternativeTenant = response.data?.data?.alternativeTenant;

    if (alternativeTenant) {
        localStorage.setItem(LocalStorageItems.TENANT_ID, alternativeTenant);

        originalRequest._retry = true;

        return axiosInstance(originalRequest);
    } else {
        return Promise.reject(error);
    }
}

function tryRetryAuthTokenError(axiosInstance: AxiosInstance, error: AxiousError) {
    const { config: originalRequest } = error;

    if (getStaticCandidateToken()) {
        sessionStorage.removeItem(SessionStorageItems.CANDIDATE_STATIC_TOKEN);

        return Promise.reject(error);
    }

    originalRequest._retry = true;

    return axiosInstance(originalRequest);
}
